import { httpPost } from '@inner-source/cis-shared/transports';

const postApplicant = ({ id, applicant }) => httpPost('/applicant', { id, applicant });

export default postApplicant;
